import React from 'react';
import PropTypes from 'prop-types';

import { BackLink } from './BackLink';

const ZenViewSubHeader = ({ backLink }) => {
  if (
    (backLink && backLink.to && backLink.label) ||
    (backLink && backLink.onClose && backLink.label)
  ) {
    return (
      <BackLink
        to={backLink.to}
        onClose={backLink.onClose}
        label={backLink.label}
      />
    );
  }

  return null;
};

ZenViewSubHeader.propTypes = {
  backLink: PropTypes.shape({
    label: PropTypes.string,
    onClose: PropTypes.func,
    to: PropTypes.string,
  }),
};

export { ZenViewSubHeader };
